import { LearningHint, learningAnchor } from 'components/learning-mode/learningHints';
import { InvoiceStatusType } from 'types/invoices';
import { t } from 'utils/getTranslations';

export const INVOICE_LEARNING_KEYS = {
    workflow: 'invoice-workflow',
    actions: 'invoice-workflow-actions',
    summary: 'invoice-summary',
    step: (status: InvoiceStatusType) => `invoice-step-${status}`,
};

/**
 * The hints for an invoice page: the lifecycle as a whole, what the current status means, and the panels. In the new
 * design's band (`inBand`) the stages and the actions run across the page, so their hints open under them.
 */
export function getInvoiceLearningHints(status: InvoiceStatusType, inBand = false): LearningHint[] {
    const statusKey = status.toLowerCase();
    const workflowSide = inBand ? 'bottom' : 'right';
    return [
        {
            element: learningAnchor(INVOICE_LEARNING_KEYS.workflow),
            title: t('invoices.learning.workflow.title'),
            description: t('invoices.learning.workflow.description'),
            side: workflowSide,
            align: 'start',
        },
        {
            element: learningAnchor(INVOICE_LEARNING_KEYS.step(status)),
            title: t(`invoices.learning.status.${statusKey}.title`),
            description: t(`invoices.learning.status.${statusKey}.description`),
            side: workflowSide,
            align: 'center',
        },
        {
            element: learningAnchor(INVOICE_LEARNING_KEYS.actions),
            title: t('invoices.learning.actions.title'),
            description: t('invoices.learning.actions.description'),
            side: workflowSide,
            align: inBand ? 'end' : 'start',
        },
        {
            element: '[data-tab-group="invoices-center-block"]',
            title: t('invoices.learning.content.title'),
            description: t('invoices.learning.content.description'),
            side: 'bottom',
            align: 'start',
        },
        {
            element: learningAnchor(INVOICE_LEARNING_KEYS.summary),
            title: t('invoices.learning.summary.title'),
            description: t('invoices.learning.summary.description'),
            side: 'left',
            align: 'start',
        },
    ];
}
